import { render, staticRenderFns } from "./tipLogo.vue?vue&type=template&id=59022902&scoped=true&"
import script from "./tipLogo.vue?vue&type=script&lang=js&"
export * from "./tipLogo.vue?vue&type=script&lang=js&"
import style0 from "./tipLogo.vue?vue&type=style&index=0&id=59022902&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59022902",
  null
  
)

export default component.exports